import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import { variables } from './Variables.js';
import TennisMain from './TennisMain.js';

export default function TennisHome() {
    const jsonUrlVideos = variables.basename_url + 'updates/index/Athlethixnet_HomeEn_Tennis.json';

    const [isLoading, setNisLoading] = useState(false);
    const [JsonVideosArray, setJsonVideosArray] = useState([]);
    const navigate = useNavigate();

    async function Get_Data_Videos() {
        setNisLoading(true);
        try {
            const response = await axios.get(jsonUrlVideos);
            setNisLoading(false);

            if (response.data && response.data.length > 0) {
                const newsItems = [];
                for (let i = 1; i <= 6 && i < response.data.length; i++) {
                    newsItems.push({
                        news_title: response.data[i].news_title,
                        news_date: response.data[i].news_date.split(" ")[0],
                        Image: response.data[i].Image,
                        link: response.data[i].link,
                        Category: response.data[i].Category
                    });
                }
                setJsonVideosArray(newsItems);
            }
        } catch (error) {
            console.error("Error fetching Tennis data:", error);
            setNisLoading(false);
        }
    }

    useEffect(() => {
        Get_Data_Videos();
    }, []);

    const customStyles = `
        .video-play-sidebar-items {
            border-bottom: 1px dashed #ddd; /* الخط المقطع بين الأخبار */
            padding-bottom: 10px;
            margin-bottom: 10px;
            height: fit-content;
        }
        .video-play-sidebar-items:last-child {
            border-bottom: none; /* إزالة الخط من آخر عنصر لتقليل المساحة */
            margin-bottom: 0;
            padding-bottom: 0;
        }
        .post-gallery-style-2 {
            display: flex; /* ترتيب الصورة بجانب النص */
            align-items: flex-start;
            gap: 12px;
        }
        .post-gallery-thumb {
            flex: 0 0 100px; /* عرض ثابت للصورة */
        }
        .post-gallery-thumb img {
            width: 100px;
            height: 70px;
            object-fit: cover; /* لضمان عدم تشوه الصورة */
            display: block;
        }
        .post-gallery-content {
            flex: 1; /* النص يأخذ باقي المساحة */
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .post-gallery-content .title {
            font-size: 14px;
            line-height: 1.3;
            margin: 0 0 5px 0;
            display: -webkit-box;
            -webkit-line-clamp: 2; /* إجبار العنوان على سطرين فقط */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .meta-post-2-style {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 12px;
            margin-top: auto; /* دفع التاريخ والاسم للأسفل */
        }
        .meta-post-categores a {
            color: #ff3d00; /* لون القسم كما في الصور */
            font-weight: 500;
        }
        .meta-post-date span {
            color: #888;
        }
    `;

    return (
        <>
            <style>{customStyles}</style>
            <div className="container custom-container">
                <div className="video-style-box mt-40">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <a href="/Tennis">
                                    <h3 className="title">Tennis News</h3>
                                </a>
                            </div>

                        </div>
                    </div>
                    <div className="row">
                        <TennisMain />

                        <div className="col-lg-6">
                            {JsonVideosArray.map((da, index) => (
                                <div key={index} className="video-play-sidebar-items">
                                    <div className="post-gallery-style-2">
                                        <div className="post-gallery-thumb">
                                            <Link to={da.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    className='rounded'
                                                    src={da.Image}
                                                    alt="tennis-news"
                                                />
                                            </Link>
                                        </div>
                                        <div className="post-gallery-content">
                                            <h5 className="title">
                                                <Link to={da.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {da.news_title}
                                                </Link>
                                            </h5>
                                            <div className="meta-post-2-style">
                                                <div className="meta-post-categores">
                                                    <Link to={da.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {da.Category}
                                                    </Link>
                                                </div>
                                                <div className="meta-post-date">
                                                    <span>{da.news_date}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}